/**************************************************
 * Nombre:       Home_Activos
 * Descripcion:
 *
 * Libreria:
 *
 * Tiempo:     5 Hr
 **************************************************/
import {Grid, Typography} from "@mui/material";
import fondo from '../../../Recursos/fondo_seccion.svg'
import ic_rendi from '../../../Recursos/ic_rendimientos.png'
import ic_visu from '../../../Recursos/ic_visualizar.png'
import ic_conecta from '../../../Recursos/ic_conectar.png'
import ic_aprovecha from '../../../Recursos/ic_aprovechar.png'
import Tarjeta_Caracteristicas from "../../Tarjetas/Tarjeta_Caracteristicas";
import {useResponsive} from "../../../Modulo_Responsive/Hooks/useResponsive";

const Home_Activos = () => {
    const {sCell} = useResponsive()

    return (
        <Grid
            container
            justifyContent={'center'}
            alignItems={'flex-start'}
            size={{xs: 12, sm: 12, md: 12}}
            sx={{
                backgroundImage: `url(${fondo})`,
                backgroundSize: 'cover',
                backgroundPosition: 'center'
            }}
        >


            <Grid
                container
                justifyContent={'center'}
                alignItems={'flex-start'}
                size={{xs: 12, sm: 12, md: 12}}
                sx={{maxWidth: '1400px', px: 3, color: '#fff', mb: 10}}
            >

                <Grid container size={{xs: 12, sm: 12, md: 10}} sx={{justifyContent: 'flex-start'}}>
                    <Grid
                        container
                        justifyContent={'center'}
                        alignItems={'flex-start'}
                        size={{xs: 12, sm: 12, md: 12}}>


                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'center', mt: 6}}>
                            <Typography
                                sx={{fontSize: sCell ? 28 : 36, fontWeight: 600, textAlign: 'center', lineHeight: 1.2}}>Haz
                                que tús activos
                                trabajen por
                                tí</Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 6}} sx={{justifyContent: 'center', mt: 2}}>
                            <Typography sx={{fontSize: 15, fontWeight: 400, textAlign: 'center'}}>
                                Automatiza y genera rendimientos diarios con el respaldo de tecnología blockchain,
                                estrategias inteligentes y activos reales en movimiento.
                            </Typography>
                        </Grid>

                        <Grid container size={{xs: 12, sm: 12, md: 12}} sx={{justifyContent: 'flex-start', mt: 8}}>
                            <Grid
                                container
                                justifyContent={'center'}
                                alignItems={'flex-start'}
                                size={{xs: 12, sm: 12, md: 12}}
                                spacing={sCell ? 2 : 8}
                            >

                                {items.map((it, index) => {
                                    return (
                                        <Grid container size={{xs: 6, sm: 4, md: 3}}
                                              sx={{justifyContent: 'flex-start'}}>
                                            <Tarjeta_Caracteristicas item={it}/>
                                        </Grid>
                                    )
                                })}

                            </Grid>
                        </Grid>

                    </Grid>
                </Grid>


            </Grid>


        </Grid>
    )

}
export default Home_Activos

const items = [
    {
        nombre: 'Rendimientos Diarios',
        descripcion: 'a través de estrategias automatizadas y optimizadas.',
        img: ic_rendi,
    },
    {
        nombre: 'Visualizar y gestionar',
        descripcion: 'tus activos digitales en tiempo real.',
        img: ic_visu,
    },
    {
        nombre: 'Conectar Activos',
        descripcion: 'físicos y digitales dentro de un ecosistema seguro.',
        img: ic_conecta,
    },
    {
        nombre: 'Aprovechar Logística',
        descripcion: 'global para mover y transformar valor de forma eficiente.',
        img: ic_aprovecha,
    },
]